const initialState = {
  fetchingNumbers: false,
  errorFetchingNumbers: null,
  showBulkSmsNumbersStatus: false,
  numbersMap: {},
  showNumbersStatus: false,
};

export default initialState;
